import React from "react";
import ReactECharts from "echarts-for-react";

const generateColor = (index) => {
  const baseColors = ["#74CB80", "#FF7BD7", "#F56B62", "#197FC7", "#56B6FC"];
  if (index < baseColors.length) return baseColors[index];

  // Generate a unique color variation using HSL manipulation
  const hueShift = (index * 137) % 360; // Spread colors evenly across hue spectrum
  return `hsl(${hueShift}, 60%, 65%)`; // Pastel-midtone color
};

const ProjectPhasePieChart = ({ claimedPhases, projectName }) => {
  const chartData = [
    {
      name: "Claimed",
      value: claimedPhases,
      itemStyle: { color: generateColor(0) },
    },
    {
      name: "Unclaimed",
      value: 100 - claimedPhases,
      itemStyle: { color: generateColor(1) },
    },
  ];

  const option = {
    title: {
      left: "center",

      textStyle: {
        fontSize: 18,
        fontWeight: "bold",
      },
    },
    tooltip: {
      trigger: "item",
      formatter: "{b}: {d}%",
    },
    legend: {
      orient: "vertical",
      bottom: "10px",
      right: "right",
    },
    series: [
      {
        name: "Phases",
        type: "pie",
        radius: "80%",
        data: chartData,
        label: {
          show: false,
        },
        labelLine: {
          show: false,
        },
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
    ],
  };

  return (
    <div className="project-status">
      <h3 className="pie-chart-summary">Phase Summary - {projectName}</h3>
      <ReactECharts
        className="pie-chart"
        option={option}
        style={{ height: "400px" }}
      />
    </div>
  );
};

export default ProjectPhasePieChart;
